import React from "react";

import { Row, Button, Icon, Copy } from "app/NativeComponents/common";

const IGNORE_VALUE = "IGNORE";
const HeaderStatus = props => {
  if (props.header_item.header_mapped_value === IGNORE_VALUE) {
    return (
      <Row>
        <Button
          onPress={() => {
            props.setHeaderOption(props.header_index, "");
          }}
        >
          <Row>
            <Icon
              icon="check_box"
              size={18}
              style={{
                marginRight: 5
              }}
            />
            <Copy>Skipped</Copy>
          </Row>
        </Button>
      </Row>
    );
  } else if (props.header_item.header_mapped_value !== "") {
    return (
      <Row>
        <Button
          style={{
            marginRight: 10
          }}
          onPress={() => {
            props.setHeaderOption(props.header_index, IGNORE_VALUE);
          }}
        >
          <Row>
            <Icon
              icon="check_box_outline_blank"
              size={12}
              style={{
                marginRight: 5
              }}
            />
            <Copy style={{ fontSize: 10 }}>Skip Column</Copy>
          </Row>
        </Button>
        <Row>
          <Icon
            icon="check_circle"
            size={18}
            color={props.colors.success_color}
            style={{
              marginRight: 5
            }}
          />
          <Copy style={{ color: props.colors.success_color }}>Mapped</Copy>
        </Row>
      </Row>
    );
  }

  return (
    <Row>
      <Button
        style={{
          marginRight: 10
        }}
        onPress={() => {
          props.setHeaderOption(props.header_index, IGNORE_VALUE);
        }}
      >
        <Row>
          <Icon
            icon="check_box_outline_blank"
            size={12}
            style={{
              marginRight: 5
            }}
          />
          <Copy style={{ fontSize: 10 }}>Skip Column</Copy>
        </Row>
      </Button>
      <Row>
        <Icon
          icon="error"
          size={18}
          style={{
            marginRight: 5
          }}
        />
        <Copy>Not mapped</Copy>
      </Row>
    </Row>
  );
};

export default React.memo(HeaderStatus);
